<template>
  <el-dialog
    v-model="dialogVisible"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    width="560px"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="媒体" prop="mediaId">
        <search-channel-select v-model="form.mediaId" style="width: 100%" />
      </el-form-item>
      <el-form-item label="需求方" prop="dspIds">
        <search-dsp-select
          v-model="dspIdList"
          :dspType="100"
          multiple
          style="width: 100%"
          @change="handleDspChange"
        />
      </el-form-item>
      <el-form-item label="需求方广告位" prop="dspSlotIds">
        <search-dsp-slot-select
          v-model="dspSlotIdList"
          :dspId="filterDspId"
          :clearOnDspChange="false"
          multiple
          style="width: 100%"
          @change="handleDspSlotChange"
        />
      </el-form-item>
      <el-form-item label="广告主" prop="advertiser">
        <el-input v-model="form.advertiser" placeholder="请输入广告主（如：美团、拼多多等），非必填" />
      </el-form-item>
      <el-form-item label="创意集" prop="creativeSetId">
        <el-select v-model="form.creativeSetId" placeholder="请选择创意集" filterable clearable style="width: 100%">
          <el-option
            v-for="item in creativeSetOptions"
            :key="item.id"
            :label="item.setName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="替换策略" prop="replaceStrategy">
        <el-radio-group v-model="form.replaceStrategy">
          <el-radio :label="1">随机</el-radio>
          <el-radio :label="2">轮询</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否开启">
        <el-switch
          v-model="form.enabled"
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addCreativeReplaceConfig, updateCreativeReplaceConfig } from '@/api/manage/creativeReplace/creativeReplace'
import { getCreativeSetList } from '@/api/manage/creativeSet/creativeSet'
import SearchChannelSelect from '@/components/SearchChannelSelect'
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'

const defaultForm = {
  id: undefined,
  mediaId: '',
  dspIds: '',
  dspSlotIds: '',
  advertiser: '',
  creativeSetId: '',
  replaceStrategy: 1,
  enabled: 1,
  remark: ''
}

export default {
  components: {
    SearchChannelSelect,
    SearchDspSelect,
    SearchDspSlotSelect
  },
  emits: ['submit'],
  data () {
    return {
      dialogVisible: false,
      submitLoading: false,
      form: Object.assign({}, defaultForm),
      dspIdList: [],
      dspSlotIdList: [],
      creativeSetOptions: [],
      rules: {
        mediaId: [{ required: true, message: '请选择媒体', trigger: 'change' }],
        creativeSetId: [{ required: true, message: '请选择创意集', trigger: 'change' }],
        replaceStrategy: [{ required: true, message: '请选择替换策略', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.form.id ? '编辑替换配置' : '新增替换配置'
    },
    filterDspId () {
      return this.dspIdList.length > 0 ? this.dspIdList[0] : undefined
    }
  },
  methods: {
    show (data) {
      this.dialogVisible = true
      this.loadCreativeSetOptions()
      if (data) {
        this.form = Object.assign({}, data)
        this.dspIdList = data.dspIds ? data.dspIds.split(',').map(Number) : []
        this.dspSlotIdList = data.dspSlotIds ? data.dspSlotIds.split(',').map(Number) : []
      }
    },
    async loadCreativeSetOptions () {
      try {
        const res = await getCreativeSetList({ pageNum: 1, pageSize: 1000 })
        if (res && res.data) {
          this.creativeSetOptions = res.data.records || []
        }
      } catch (e) {
        console.error('加载创意集选项失败', e)
      }
    },
    handleDspChange () {
      this.form.dspIds = this.dspIdList.join(',')
      this.dspSlotIdList = []
      this.form.dspSlotIds = ''
    },
    handleDspSlotChange () {
      this.form.dspSlotIds = this.dspSlotIdList.join(',')
    },
    close () {
      this.dialogVisible = false
      this.reset()
    },
    reset () {
      this.form = Object.assign({}, defaultForm)
      this.dspIdList = []
      this.dspSlotIdList = []
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    submit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        const submitData = Object.assign({}, this.form, {
          dspIds: this.dspIdList.join(','),
          dspSlotIds: this.dspSlotIdList.join(',')
        })
        const api = this.form.id ? updateCreativeReplaceConfig : addCreativeReplaceConfig
        api(submitData).then((res) => {
          if (res.code === 200) {
            this.$message.success(this.form.id ? '编辑成功' : '新增成功')
            this.$emit('submit')
            this.close()
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 18px;
}
</style>
